import React from 'react';

const BulkScoutButton = ({ circleId, maxSelectable }) => {
  const [selectedCount, setSelectedCount] = React.useState(0);
  const lastBulkActionRef = React.useRef(null);

  React.useEffect(() => {
    const checkboxes = Array.from(
      document.querySelectorAll('.scout-bulk-checkbox')
    );
    const selectAllToggleButton = document.getElementById(
      'scout-select-all-toggle'
    );

    const updateSelectedCount = () => {
      const count = checkboxes.filter((checkbox) => checkbox.checked).length;
      setSelectedCount(count);
    };

    const syncToggleLabel = (mode) => {
      if (!selectAllToggleButton) return;
      selectAllToggleButton.textContent = mode === 'select' ? '全選択' : '全解除';
    };

    const selectAll = () => {
      const limit =
        typeof maxSelectable === 'number' ? maxSelectable : checkboxes.length;
      let checkedCount = 0;
      checkboxes.forEach((checkbox) => {
        if (checkedCount < limit) {
          checkbox.checked = true;
          checkedCount += 1;
        } else {
          checkbox.checked = false;
        }
      });
      lastBulkActionRef.current = 'select';
      syncToggleLabel('clear');
      updateSelectedCount();
    };

    const clearAll = () => {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
      lastBulkActionRef.current = 'clear';
      syncToggleLabel('select');
      updateSelectedCount();
    };

    const toggleSelectAll = () => {
      if (lastBulkActionRef.current === 'select') {
        clearAll();
      } else {
        selectAll();
      }
    };

    const handleCheckboxChange = (event) => {
      if (event.target.checked) {
        const limit =
          typeof maxSelectable === 'number' ? maxSelectable : null;
        if (limit !== null) {
          const count = checkboxes.filter((checkbox) => checkbox.checked).length;
          if (count > limit) {
            event.target.checked = false;
            alert(`最大${limit}件まで選択できます`);
          }
        }
      }
      updateSelectedCount();
    };

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', handleCheckboxChange);
    });
    if (selectAllToggleButton) {
      selectAllToggleButton.addEventListener('click', toggleSelectAll);
    }

    updateSelectedCount();
    syncToggleLabel('select');

    return () => {
      checkboxes.forEach((checkbox) => {
        checkbox.removeEventListener('change', handleCheckboxChange);
      });
      if (selectAllToggleButton) {
        selectAllToggleButton.removeEventListener('click', toggleSelectAll);
      }
    };
  }, []);

  const handleClick = () => {
    const checkboxes = Array.from(
      document.querySelectorAll('.scout-bulk-checkbox')
    );
    const selected = checkboxes.filter((checkbox) => checkbox.checked);

    if (selected.length === 0) {
      alert('送信先を選択してください');
      return;
    }

    const params = selected
      .map((checkbox) => `user_ids[]=${encodeURIComponent(checkbox.value)}`)
      .join('&');
    window.location.href = `/circle/${circleId}/scouts/new?${params}`;
  };

  return (
    <button
      className="btn btn-outline-secondary d-flex align-items-center"
      type="button"
      style={{ borderRadius: '50px', padding: '8px 24px', gap: '4px' }}
      onClick={handleClick}
    >
      <span>{`スカウトを送る(${selectedCount})`}</span>
    </button>
  );
};

export default BulkScoutButton;
